var _ellipse, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileDuringEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 65.0862,
    rx: 60,
    ry: 60,
    transform: "rotate(90 65 65.0862)",
    fill: "url(#paint0_linear_641_6815)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_641_6815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.2498,
    y: 24.3364,
    width: 82.0513,
    height: 82.0513,
    rx: 41.0256,
    fill: "#5449C5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3952 48.4389C63.3952 47.4005 64.2371 46.5586 65.2756 46.5586C66.3141 46.5586 67.1559 47.4005 67.1559 48.4389V50.4357C73.9604 51.2842 79.3534 56.6772 80.2019 63.4817H82.1987C83.2371 63.4817 84.079 64.3235 84.079 65.362C84.079 66.4005 83.2371 67.2424 82.1987 67.2424H80.2019C79.3534 74.0468 73.9604 79.4399 67.1559 80.2884V82.2851C67.1559 83.3236 66.3141 84.1654 65.2756 84.1654C64.2371 84.1654 63.3952 83.3236 63.3952 82.2851V80.2884C56.5908 79.4399 51.1977 74.0468 50.3492 67.2424H48.3525C47.314 67.2424 46.4722 66.4005 46.4722 65.362C46.4722 64.3235 47.314 63.4817 48.3525 63.4817H50.3492C51.1977 56.6772 56.5908 51.2842 63.3952 50.4357V48.4389ZM53.9935 65.362C53.9935 71.5929 59.0447 76.6441 65.2756 76.6441C71.5065 76.6441 76.5576 71.5929 76.5576 65.362C76.5576 59.1311 71.5065 54.08 65.2756 54.08C59.0447 54.08 53.9935 59.1311 53.9935 65.362Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0363 65.362C69.0363 67.439 67.3525 69.1227 65.2756 69.1227C63.1986 69.1227 61.5149 67.439 61.5149 65.362C61.5149 63.285 63.1986 61.6013 65.2756 61.6013C67.3525 61.6013 69.0363 63.285 69.0363 65.362Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_6815",
    x: 0.249756,
    y: 0.336426,
    width: 154.051,
    height: 154.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.113725 0 0 0 0 0.298039 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_6815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_6815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_6815",
    x1: 65.4602,
    y1: 4.57337,
    x2: 65.4602,
    y2: 124.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463DA3",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDuringEvent);
export default __webpack_public_path__ + "static/media/mobile-during-event.07a02a479d874b9464a0b9d7ae78e4c0.svg";
export { ForwardRef as ReactComponent };